import { useMonarchRule } from "../MonarchRulesProvider";
import type {
  GuidedPathVsDynamicFlowData,
  UseGuidedPathVsDynamicFlow,
} from "./types";

const RULE_ID = "guidedPathVsDynamicFlow";

const useGuidedPathVsDynamicFlow: UseGuidedPathVsDynamicFlow = () => {
  const { isLoading, value } = useMonarchRule<GuidedPathVsDynamicFlowData>(
    RULE_ID,
    {},
  );

  if (isLoading) {
    return {
      isLoading,
      variant: "control",
    };
  }

  const variant = value?.enabled ? "test" : "control";

  return {
    isLoading: false,
    variant,
    data: value || {},
  };
};

export default useGuidedPathVsDynamicFlow;
